import { render, staticRenderFns } from "./mr_widget_auto_merge_enabled.vue?vue&type=template&id=47356f3c"
import script from "./mr_widget_auto_merge_enabled.vue?vue&type=script&lang=js"
export * from "./mr_widget_auto_merge_enabled.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports